import { useState } from 'react';

import { CloseRounded } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';

import { ICoSettlementAgentObj } from '../../../../types/SettlementAgent';
import { DocGenerationSource } from '../../../constants/docGenerationSource';
import InviteCoSaPanel from './InviteCoSaPanel';
import InviteCoSettlementAgentActions from './InviteCoSettlementAgentActions';

export interface IAddCoSa {
  open: boolean;
  maxCapacity: number;
  existingCoSa: any;
  orderType: string;
  isAddingCoSettlement?: boolean;
  onClose?: () => void;
  existingSettlementAgentsOnTheOrder: string[];
  getExistingSettlementAgentByEmail: (email: string) => any;
  addCosettlementAgents: (data: ICoSettlementAgentObj[]) => void;
}

const AddCoSettlementAgent = (props: IAddCoSa) => {
  const {
    open,
    maxCapacity,
    existingCoSa,
    existingSettlementAgentsOnTheOrder,
    isAddingCoSettlement,
    orderType,
    addCosettlementAgents,
    getExistingSettlementAgentByEmail,
    onClose,
  } = props;

  const [isReviewing, setIsReviewing] = useState<boolean>(false);
  const [isListValid, setIsListValid] = useState<boolean>(false);
  const [confirmChecked, setConfirmChecked] = useState<boolean>(false);
  const [listPreview, setListPreview] = useState<
    Map<number, ICoSettlementAgentObj> | undefined
  >();

  const handleAddEmails = (newCoSa: ICoSettlementAgentObj[]) => {
    addCosettlementAgents(newCoSa);
  };

  const handleReviewStatus = (isReviewing: boolean) => {
    setIsReviewing(isReviewing);
  };

  const handleValidity = (isValid: boolean) => {
    setIsListValid(isValid);
  };

  const handlePreview = (map: Map<number, ICoSettlementAgentObj>) => {
    setListPreview(map);
  };

  const handleClose = () => {
    handleResetFields();
    if (onClose) {
      onClose();
    }
  };

  const handleResetFields = () => {
    setIsReviewing(false);
    setIsListValid(false);
    setListPreview(undefined);
  };

  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={open}
      scroll={'paper'}
      aria-labelledby='form-dialog-title'>
      <DialogTitle>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
          <Grid item sx={{ flexGrow: 1, flexShrink: 0 }}>
            {orderType === DocGenerationSource.FA
              ? 'Add Escrow Assistant'
              : 'Add Co-Settlement Agent'}
          </Grid>
          <Grid item sx={{ flexGrow: 0, flexShrink: 1 }}>
            <IconButton
              color='inherit'
              onClick={handleClose}
              component='button'>
              <CloseRounded fontSize='inherit' />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <>
        {isAddingCoSettlement && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '200px',
            }}>
            <Typography variant='h6'>
              {orderType === DocGenerationSource.FA
                ? 'Adding Escrow Assistants...'
                : 'Adding Co-Settlement Agents...'}
            </Typography>
            <CircularProgress />
          </Box>
        )}
        {!isAddingCoSettlement && (
          <>
            <DialogContent dividers>
              <InviteCoSaPanel
                orderType={orderType}
                maxCapacity={maxCapacity}
                existingCoSa={existingCoSa}
                isReviewing={isReviewing}
                existingSettlementAgentsOnTheOrder={
                  existingSettlementAgentsOnTheOrder
                }
                setIsListValid={(isValid: boolean) => handleValidity(isValid)}
                listPreview={listPreview}
                confirmChecked={(checked) => setConfirmChecked(checked)}
                setPreview={(answerMap) => handlePreview(answerMap)}
                getExistingSettlementAgentByEmail={
                  getExistingSettlementAgentByEmail
                }
              />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
              <InviteCoSettlementAgentActions
                onClose={handleClose}
                orderType={orderType}
                addCoSa={handleAddEmails}
                isReviewing={isReviewing}
                setReviewStatus={(isReviewing: boolean) =>
                  handleReviewStatus(isReviewing)
                }
                isListValid={isListValid}
                confirmChecked={confirmChecked}
                listPreview={listPreview}
              />
            </DialogActions>
          </>
        )}
      </>
    </Dialog>
  );
};

export default AddCoSettlementAgent;
